module.exports = __webpack_public_path__ + "img/RX-Arcos-6-zoom.f20d5791.png";